<template>
    <div class="wrapper_btn">

        <button

            @click="click"
            role="button"
            id="cta_next"
            class="cta next"
            :disabled="waiting">

            <span v-if="!waiting"> {{ label }}</span>
            <span v-if="waiting"> {{ copydeck.page_coords.btn_processing[lang]}} ...</span>

        </button>
    </div>
</template>

<script>
export default {
    name: "WaitableButton"
}
</script>

<script setup>

    import {storeToRefs} from "pinia";
    import {useMainStore} from "../stores/main";

    let props = defineProps(["waiting", "label"])
    let emits = defineEmits(["click"]);

    let store = useMainStore();
    let { copydeck, lang } = storeToRefs(store);

    function click ()
    {
        emits("click")
    }

</script>
<style scoped>

</style>
